/**
 * @copyright 2025 Glimbr Pty Ltd
 * @version 2026-04-19-v1
 */
import { Link } from 'react-router-dom';
import { ArrowDown, ArrowUp, Minus } from 'lucide-react';
import { Sparkline } from './sparkline';
import type { Kpi } from '../../lib/types';

export function KpiTile({ kpi }: { kpi: Kpi }) {
    const dir = kpi.delta.direction;
    const Icon = dir === 'up' ? ArrowUp : dir === 'down' ? ArrowDown : Minus;
    return (
        <Link to={kpi.href} className="kpi-tile" data-alert={kpi.alert ? 'true' : 'false'}>
            <span className="label">{kpi.label}</span>
            <span className="value">{kpi.value}</span>
            <div className="footer">
                <span className="delta" data-dir={dir}>
                    <Icon size={11} strokeWidth={2.5} />
                    {kpi.delta.pct}
                </span>
                <Sparkline data={kpi.spark} />
            </div>
        </Link>
    );
}
